import { BASE_URL, COUNTRY_CODE } from "@utils/constants";
import { getCookieValue } from "@utils/helpers";
import axios from "axios";
import { mutate } from "swr";

export const customFetcher = async ([url, params]: [string, string]) => {
  let basketKey = getCookieValue("ASP.NET_SessionId");
  const websiteUid = getCookieValue("itk-website-uid");
  const locale = getCookieValue("NEXT_LOCALE");

  return axios
    .get(`${BASE_URL}/legacy/${COUNTRY_CODE}/shop/${url}`, {
      headers: {
        "basket-key": basketKey,
        "content-language": locale,
        "itk-website-uid": websiteUid,
      },
    })
    .then(async (res) => {
      if (res.status === 401) {
        await fetch(`/api/basket`, {
          method: "DELETE",
        });

        await fetch(`/api/basket`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        });

        await mutate(`${url}`);
        return null;
      }

      if (res.status !== 200 && res.status !== 429) return null;
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
